import { useEffect, useState } from 'react';
import { Alert, Button } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { canRrhh } from '../../services/rrhhAccess';
import { ASISTENCIA_SCAN_DRAFT_CHANGED, leerEstadoBorradorEscaneoAsistencia } from '../../services/asistenciaOfflineService';

export default function AsistenciaScanRecoveryNotice() {
    const { user } = useAuth();
    const { pathname } = useLocation();
    const [available, setAvailable] = useState(false);
    const allowed = canRrhh(user, 'asistencias.informar_propia') && canRrhh(user, 'asistencias.adjuntar_documentos');
    useEffect(() => {
        let disposed = false;
        setAvailable(false);
        if (!allowed || !user?.id || pathname === '/mi-asistencia/informar') return undefined;
        const reload = async () => {
            try {
                const row = await leerEstadoBorradorEscaneoAsistencia(user.id);
                if (!disposed) setAvailable(Boolean(row && Number(row.payload?.user_id) === Number(user.id)));
            } catch { if (!disposed) setAvailable(false); }
        };
        void reload();
        window.addEventListener(ASISTENCIA_SCAN_DRAFT_CHANGED, reload);
        return () => { disposed = true; window.removeEventListener(ASISTENCIA_SCAN_DRAFT_CHANGED, reload); };
    }, [allowed, user?.id, pathname]);
    if (!available || !allowed || pathname === '/mi-asistencia/informar') return null;
    return <Alert severity="info" role="status" sx={{ mb: 1.25, py: 0.4, px: 1.25, '& .MuiAlert-message': { minWidth: 0, fontSize: '0.78rem' }, '& .MuiAlert-action': { alignItems: 'center', m: 0, pl: 1 } }}
        action={<Button component={Link} to="/mi-asistencia/informar" size="small" sx={{ minHeight: 32, fontSize: '0.75rem', px: 1 }}>Recuperar aviso</Button>}>
        Tenés un aviso preparado al escanear. Podés recuperarlo y revisarlo antes de guardar.
    </Alert>;
}
